<template>
    <WalletAnnoucement/>
    <router-view v-if="init" :key="$route.fullPath"></router-view>
</template>
<script>
import { computed, defineAsyncComponent } from 'vue';
import { getWalletAuth} from '../services/module';
import WalletAnnoucement from '../components/WalletAnnoucement.vue';
export default {
    name: "WalletModule",
    components: {
        WalletAnnoucement
    },
    data() {
        return {
            init: false,
            config: null,
        }
    },
      provide() {
        return { 
            walletConfig : computed(() => this.config),
            onlyBank: computed(() => !!this.config?.agents.find(agent => agent == this.$auth.user.cpi) || false)
        }
    },
    created() {
        if(!this.$auth?.user?.isDemoLogin){
            this.getWalletAuth();
        }else{
            this.$errorToast('Wallet access is restricted for demo users')
            this.$router.push({name:'Home'})
        }
    },
    methods: {
         async getWalletAuth() {
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        }
       
    }
}
</script>